import script from "./general.vue?vue&type=script&setup=true&lang=js"
export * from "./general.vue?vue&type=script&setup=true&lang=js"

import "./general.vue?vue&type=style&index=0&id=462467dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-462467dc"]])

export default __exports__